import { render, staticRenderFns } from "./TenancyOverview.vue?vue&type=template&id=15e90f6e&scoped=true&"
import script from "./TenancyOverview.vue?vue&type=script&lang=js&"
export * from "./TenancyOverview.vue?vue&type=script&lang=js&"
import style0 from "./TenancyOverview.vue?vue&type=style&index=0&id=15e90f6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e90f6e",
  null
  
)

export default component.exports